import React from 'react';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-414" data-mp="2vcs8vn7qax3f">
      <Header data-id="element-415" data-mp="304tq7njr7e0b" />
      <Navigation data-id="element-416" data-mp="304jwppzi2opv" />
      <main className="flex-1" data-id="element-417" data-mp="3053en6p5hd3w">{children}</main>
      <Footer data-id="element-418" data-mp="353ddbra32vu9" />
    </div>;
}